import Component from '@glimmer/component';

import eq from 'rise-ui/helpers/eq.js';

export default class OptionComponent extends Component {
  <template>
    <option
      class="c-option"
      value={{@value}}
      selected={{if (eq @selected @value) "true"}}
      ...attributes
    >{{yield}}</option>
  </template>
}
